import {
    Box, Typography, Grid, Button, TableContainer, Table,
    TableHead, TableRow, TableCell, TableBody, tableCellClasses,
    TableFooter
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';

import { Icon, Input, PopUp } from '../ui';
import { convertToNominal } from '../../utils/masks';

const ModalApprovalCredit = React.memo(({
    titleModal,
    isModal,
    handleClick,
    title,
    approvalData,
    approvalDataList,
    customerName,
    creditType,
    approvalIDR,
    approvalUSD
}) => {
    const [ApprovalRemarks, setApprovalRemarks] = useState('');

    useEffect(() => {
        setApprovalRemarks('');
    }, [isModal]);

    const handleApprovalCredit = useCallback(() => {
        approvalData(ApprovalRemarks);
    }, [approvalData, ApprovalRemarks]);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#F2FAFF',
            color: 'var(--Primary-One, #083A50)',
            fontFamily: 'Nunito',
            fontSize: '14px',
            fontstyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
            padding: '8px 16px !important',
        },
    }));

    const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.body}`]: {
            color: 'var(--Blue-Primary-1, #083A50)',
            fontFamily: 'Nunito',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            padding: '0px 16px !important',
            height: '35px !important'
        },
    }));

    const StyledTableFooterCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.footer}`]: {
            background: '#E4E8EC',
            color: '#083A50 !important',
            fontFamily: 'Nunito',
            fontSize: '13px',
            fontstyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
            padding: '8px 16px !important',
            left: 0,
            bottom: 0,
            zIndex: 2,
            position: 'sticky',
        },
    }));

    const mainContainer = (
        <>
            <Box sx={{ marginTop: '16px' }}>
                <TableContainer sx={{ maxHeight: 305, borderRadius: '12px', background: '#FFF' }}>
                    <Table sx={{ minWidth: 450 }} size='small' aria-label="a dense table" stickyHeader>
                        <TableHead
                            sx={{
                                '& th:first-child': {
                                    borderRadius: '12px 0 0'
                                },
                                '& th:last-child': {
                                    borderRadius: '0 12px 0 0'
                                }
                            }}
                        >
                            <TableRow>
                                <StyledTableCell>Used On</StyledTableCell>
                                <StyledTableCell sx={{ textAlign: 'center' }}>Transaction Number</StyledTableCell>
                                {creditType !== 'Days' && <StyledTableCell sx={{ textAlign: 'right' }}>Amount</StyledTableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                approvalDataList.length > 0 ?
                                    approvalDataList.map((el) => {
                                        return (
                                            <TableRow key={el.sequence} hover={true}>
                                                <StyledTableBodyCell>{el.usedOn}</StyledTableBodyCell>
                                                <StyledTableBodyCell sx={{ textAlign: 'center' }}>{el.transactionNumber}</StyledTableBodyCell>
                                                {creditType !== 'Days' && <StyledTableBodyCell sx={{ textAlign: 'right' }}>{convertToNominal(creditType === 'Amount IDR' ? el.amountIDR : el.amountUSD)}</StyledTableBodyCell>}
                                            </TableRow>
                                        )
                                    })
                                    :
                                    <TableRow>
                                        <StyledTableBodyCell colSpan='100%' sx={{ textAlign: 'center' }}>
                                            <Typography
                                                sx={{
                                                    color: 'var(--Primary-One, #083A50)',
                                                    fontFamily: 'Nunito',
                                                    fontSize: '12px',
                                                    fontstyle: 'normal',
                                                    fontWeight: '500',
                                                    lineHeight: 'normal'
                                                }}
                                            >
                                                Data Empty
                                            </Typography>
                                        </StyledTableBodyCell>
                                    </TableRow>
                            }
                        </TableBody>
                        {
                            creditType !== 'Days' && (
                                <TableFooter
                                    sx={{
                                        left: 0,
                                        bottom: 0,
                                        zIndex: 2,
                                        position: 'sticky',
                                        background: '#E4E8EC',
                                        '& td:first-of-type': {
                                            borderRadius: '0 0 0 12px'
                                        },
                                        '& td:last-child': {
                                            borderRadius: '0 0 12px 0'
                                        }
                                    }}
                                >
                                    <TableRow>
                                        <StyledTableFooterCell sx={{ textAlign: 'center', }} colSpan={2}>
                                            Total {creditType}
                                        </StyledTableFooterCell>
                                        <StyledTableFooterCell sx={{ textAlign: 'right', }}>
                                            {creditType === 'Amount IDR' ? convertToNominal(approvalIDR) : convertToNominal(approvalUSD)}
                                        </StyledTableFooterCell>
                                    </TableRow>
                                </TableFooter>
                            )
                        }
                    </Table>
                </TableContainer>
            </Box>

            <Box className='mt-4'>
                <Input
                    label={'Reason'}
                    multiline
                    fullWidth
                    value={ApprovalRemarks}
                    onChange={(e) => setApprovalRemarks(e.target.value)}
                    formControlProps={{
                        sx: {
                            width: '100%',
                        }
                    }}
                    inputBaseProps={{
                        rows: 5,
                        sx: {
                            padding: '8px',
                        },
                    }}
                />
            </Box>
        </>
    )

    return (
        <>
            <PopUp
                id='modal-id'
                icon={
                    <Icon
                        iconName={'approve-doc'}
                        svgIconProps={{
                            htmlColor: '#083A50',
                            sx: {
                                height: '20px',
                                width: '20px'
                            }
                        }}
                    />
                }
                title={'Approval Credit'}
                isOpen={isModal}
                onClose={handleClick}
                draggable={false}
                shrinkable={false}
                disableScrollLock={false}
                maxWidth={'sm'}
                fullWidth={true}
                topButton={true}
            >
                <div style={{ padding: '24px 6px 16px' }}>
                    <Box display="flex">
                        <Typography
                            sx={{
                                fontFamily: 'Nunito',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '20px',
                                letterSpacing: '0em',
                                textAlign: 'left',
                            }}
                        >
                            You can't {title} {titleModal} because {customerName} was overshot Credit Limit ({creditType}):
                        </Typography>
                    </Box>

                    {mainContainer}
                </div>

                <div style={{ padding: '24px 6px 0px' }}>
                    <Box display="flex" alignItems="center">
                        <Grid container item direction="row">
                            <Grid item xs={12} className='text-end' display={'flex'} justifyContent={'flex-end'}>
                                <Button
                                    size='small'
                                    variant="outlined"
                                    className='d-flex align-items-center'
                                    sx={{
                                        padding: '4px 12px !important',
                                        gap: '4px',
                                        marginInlineStart: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '32px !important',
                                        borderRadius: '8px',
                                        background: 'var(--Blue-Button-Primary-1, #0087C2)',
                                        '&:hover': {
                                            backgroundColor: 'var(--Blue-Button-Primary-1, #0087C2) !important',
                                            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.20)',
                                        }
                                    }}
                                    onClick={handleApprovalCredit}
                                >
                                    <Icon
                                        svgIconProps={{
                                            htmlColor: '#E4E8EC',
                                            sx: {
                                                height: '14px',
                                                width: '14px'
                                            }
                                        }}
                                        iconName={'checklist'}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: 'Nunito',
                                            marginTop: '3px !important',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            lineHeight: '20px',
                                            textAlign: 'center',
                                            color: '#E4E8EC',
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                </Button>

                                <Button
                                    size='small'
                                    variant="outlined"
                                    className='d-flex align-items-center'
                                    sx={{
                                        padding: '4px 12px !important',
                                        gap: '4px',
                                        marginInlineStart: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '32px !important',
                                        borderRadius: '8px',
                                        border: '1px solid var(--Red-Alert, #D20C0C)',
                                        background: 'rgba(210, 12, 12, 0.25)',
                                        '&:hover': {
                                            border: '1px solid var(--Red-Alert, #D20C0C)',
                                            background: 'rgba(210, 12, 12, 0.25)',
                                            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.20)',
                                        }
                                    }}
                                    onClick={handleClick}
                                >
                                    <Icon
                                        svgIconProps={{
                                            htmlColor: '#D20C0C',
                                            sx: {
                                                height: '14px',
                                                width: '14px'
                                            }
                                        }}
                                        iconName={'close'}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: 'Nunito',
                                            marginTop: '3px !important',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            lineHeight: '20px',
                                            textAlign: 'center',
                                            color: '#D20C0C',
                                        }}
                                    >
                                        Cancel
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </PopUp>
        </>
    )
})

export default React.memo(ModalApprovalCredit);